import type { TaxonomyEntry } from 'src/redux/content/types';
import { normaliseForMatch } from 'src/utils/selectTaxonomyContentEntry';

/**
 * Builds a reusable predicate that decides whether a link's `href` should be
 * crawlable (a real, followable `<a>`): true only when the href exactly matches a
 * neighbourhood-map entry that is indexable. The same exact-match signal that
 * drives the page's own meta robots / canonical tags ({@link selectExactTaxonomyEntry}),
 * reused for outbound link followability.
 *
 * Normalises the indexable URLs once up front so checking many hrefs against the
 * same map is a single normalise + set lookup per href, not a re-normalise of
 * every entry per href.
 */
export const createCrawlableHrefMatcher = (
  entries: TaxonomyEntry[],
): ((href: string) => boolean) => {
  const indexableUrls = new Set(
    entries.filter((entry) => entry.indexable).map((entry) => normaliseForMatch(entry.url)),
  );

  return (href) => indexableUrls.has(normaliseForMatch(href));
};
